import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IFileDownloadModel, IFileValidationModel } from "src/app/ViewModel/File.Model";
import { environment } from "src/environments/environment";
import { CommonService } from "../Common.service";
import { EncryptDecryptService } from "../encrypt-decrypt.service";
import { RestApiService } from "../rest-api.service";

export enum FileUploadLibrary {
    WorkflowDocument = 1,
    Documents = 2,
    CCNDocuments = 3,
    Communication = 4,
    SignedDocuments = 5
}

@Injectable({ providedIn: "root" })
export class FileService {
    private baseUrl = environment.uriHost;
    private endPoints = {
        uploadChunk: this.baseUrl + '/ManageFile/UploadChunk',
        uploadChunkFile: this.baseUrl + '/ManageFile/UploadChunkFile',
        uploadStatus: 'ManageFile/FileUploadStatus',
        validateFile: "ManageFile/ValidateFiles",
        getFiles: "ManageFile/GetFiles",
        downloadFile: "/ManageFile/DownloadFileByLibrary",
        deleteFile: "ManageFile/DeleteFileByLibrary",
        downloadAllAttachments: '/ManageFile/downloadAllFiles',
    }
    constructor(private http: HttpClient, private restAPTService: RestApiService, private commonService: CommonService, private encryptDecryptService: EncryptDecryptService) {

    }
    public UploadChunk(chunk: any, headers: any): Observable<any> {
        return this.http.post(this.endPoints.uploadChunk, chunk, { headers: headers });
    }

    public UploadChunkFile(formData: FormData) {
        const headers = {
            'X-Requested-With': 'XMLHttpRequest',
            'Authorization': 'Bearer ' + this.commonService.getJWT(),
            'loginAuditNumber': this.encryptDecryptService.decrypt(this.commonService.getLoginAuditNumber())
        }
        return this.http.post<any>(this.endPoints.uploadChunkFile, formData, { 'headers': headers });
    }
    public GetFileUploadStatus(fileInfo: IFileValidationModel): Observable<any> {
        return this.restAPTService.new_POST(this.endPoints.uploadStatus, fileInfo)
    }

    public ValidateFiles(validateFileInfo: IFileValidationModel): Observable<any> {
        return this.restAPTService.new_POST(this.endPoints.validateFile, validateFileInfo)
    }

    public GetFiles(files: IFileValidationModel) {
        return this.restAPTService.new_POST(this.endPoints.getFiles, files)
    }

    public DeleteFile(fileModel: IFileDownloadModel): Observable<any> {
        return this.restAPTService.new_POST(this.endPoints.deleteFile, fileModel)
    }

    public DownloadFile(fileModel: IFileDownloadModel): Observable<Blob> {
        let _apiURL = environment.uriHost + this.endPoints.downloadFile;
        const headers = {
            'X-Requested-With': 'XMLHttpRequest',
            'Authorization': 'Bearer ' + this.commonService.getJWT(),
            'loginAuditNumber': this.encryptDecryptService.decrypt(this.commonService.getLoginAuditNumber())
        }
        return this.http.post(_apiURL, fileModel, { 'headers': headers, responseType: 'blob' });
    }

    public DownloadAllFiles(files: Array<IFileValidationModel>) {
        let _apiURL = environment.uriHost + this.endPoints.downloadAllAttachments;
        const headers = {
            'X-Requested-With': 'XMLHttpRequest',
            'Authorization': 'Bearer ' + this.commonService.getJWT(),
            'loginAuditNumber': this.encryptDecryptService.decrypt(this.commonService.getLoginAuditNumber())
        }
        return this.http.post(_apiURL, files, { 'headers': headers, responseType: 'blob' });
    }
}